import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
  @Input() message:any;
  @Output() onClosedMessage = new EventEmitter<boolean>();
  public close:boolean;
  constructor() {

   }

  ngOnInit() {
    this.close = false;
  }

  public closeMessage(){
    console.log("LLEGA AL METODO");
    this.onClosedMessage.emit(this.close);
    console.log("YA PASÓ");
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/message/message.component.ts